/**
 * 截取字符串
 * @param {string} str
 * @param {number} len
 * @param {sreing} sup
 * @returns
 */
export function filStrSubstring(str, len, sup = '...') {
  if (str && str.length > len) {
    return str.substring(0, len) + sup;
  }
  return str;
}
/**
 * 1.00 =》 1
 * @param {*} str
 * @returns
 */
export function filStrReplace(str, rep) {
  if (str && str.indexOf(rep) !== -1) {
    return str.replace(rep, '');
  }
  return str;
}